import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import React from "react"
import {StyledLabel, StyledLabelProps} from "./style"

type Props = InjectIntl &
  StyledLabelProps & {
    iconColor?: string
    icon?: IconTypes
    intlId: string
  }

const DealLabel = ({iconColor, icon, intlId, formatMessage, ...props}: Props) => {
  return (
    <Flex alignItems="center">
      {icon && <Icon marginRight={1} icon={icon} size={10} color={iconColor} />}
      <StyledLabel {...props}>{formatMessage({id: intlId})}</StyledLabel>
    </Flex>
  )
}

export default injectIntl(DealLabel)
